import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useTrace } from '../../utils/trace';
/**
 * A skeleton component to display a loading state for a table.
 *
 * It takes the number or rows and columns to display, and an optional action column.
 *
 * [Documentation](https://wds2docs.dev-sqnt.com/?path=/docs/components-tableskeleton)
 *
 * ### Example
 * ```tsx
 * <TableSkeleton
 *     rows={5}
 *     columns={5}
 *     hasAction
 * />
 * ```
 * @param param0
 * @returns
 */
export default function TableSkeleton({ hasAction, rows, columns, actionSx, skeletonSx, rowSx, 'automation-id': automationId, }) {
    // Ensure integer numbers greater than zero are provided
    const rowCount = columns > 0 ? Number.parseInt(rows.toString(), 10) : 1;
    const columnCount = columns > 0 ? Number.parseInt(columns.toString(), 10) : 1;
    const getFullTrace = useTrace(automationId !== null && automationId !== void 0 ? automationId : 'table-skeleton');
    return (_jsx(_Fragment, { children: [...Array(rowCount)].map((row, index) => (_jsxs(TableRow, { "automation-id": getFullTrace(`row-${index}`), sx: Object.assign({ width: '100%' }, rowSx), children: [[...Array(columnCount)].map((col, cellIndex) => (_jsx(TableCell, { children: _jsx(Skeleton, { animation: "wave", variant: "text", width: "auto", sx: Object.assign({ height: '32px' }, skeletonSx) }) }, cellIndex))), hasAction && (_jsx(TableCell, { "automation-id": getFullTrace(`row-${index}-action`), children: _jsx(Skeleton, { animation: "wave", sx: actionSx, variant: "circular", width: 32, height: 32 }) }))] }, index))) }));
}
//# sourceMappingURL=TableSkeleton.js.map